import type { OurContext } from '../context';
import { buildStandardHeaders, request } from '../util/network';

export const cancel = async (context: OurContext): Promise<void> => {
  if (!context.claims) {
    return;
  }
  await request(
    context.claims.url,
    'DELETE',
    buildStandardHeaders(context.apiSubscriptionId, context.apiAuth),
    undefined,
    1
  );
};
